export default function FileUploaderService(FileUploader) {
  'ngInject';
  return new FileUploader();
}